import { Component } from 'react';
import { AuthContext } from "./../context/auth";
import {ApiBaseUrl} from './../constants';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class AddtoShareComponent extends Component{
    static contextType = AuthContext;

    componentDidMount(){
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const deal_type = params.get('deal_type');

        window.scrollTo(0, 0)
        if(!this.context.authenticated) {
            if(window.confirm('You have to login/register to see the shared deal')) {
                const AddToShare = { 'deal_id': this.props.match.params.deal_id, 'host_id': this.props.match.params.host_id, 'deal_type': deal_type };
                localStorage.setItem('silverbackAddToShare', JSON.stringify(AddToShare));
                this.props.history.push(process.env.PUBLIC_URL + '/login');
            }
            else
                this.props.history.push(process.env.PUBLIC_URL+'/');
            return;
        }

        const requestBody = 'deal_id='+this.props.match.params.deal_id+'&host_id='+this.props.match.params.host_id
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/add_to_share/",
            {
                method: 'POST',
                body: requestBody,
                headers:
                    {
                        "Content-Type" : "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if(result.success) {
                        if(deal_type === 'allday')
                            this.props.history.push(process.env.PUBLIC_URL+'/allday/shared-deal/'+result.data._id);
                        else if(deal_type === 'oneday')
                            this.props.history.push(process.env.PUBLIC_URL+'/oneday/shared-deal/'+result.data._id);
                        else
                            this.props.history.push(process.env.PUBLIC_URL+'/allday/shared-deal/');
                    }
                    else
                        this.props.openSnackbar(result.message)
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    render(){
        return null
    }
}

export default withSnackbar(AddtoShareComponent,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});